import axiosInstance from "../axiosInstance";
import { pickDefaultAnalyticsWarehouse } from "../analyticsWarehouses";

// Warehouse options for ANALYTICS pickers only. Honors the client's
// "Analytics Warehouses" configuration (unconfigured clients get every
// warehouse, paged + searchable). Operational pickers keep using
// wmsService.fetch (/warehouse), which this does not affect.
export const analyticsWarehouseService = {
  fetch: async ({ clientId, search = "", limit = 15, skip = 0, signal } = {}) => {
    const params = new URLSearchParams();
    if (clientId) params.set("client_id", clientId);
    params.set("$limit", String(limit));
    params.set("$skip", String(skip));
    const q = (search || "").trim();
    if (q) params.set("search", q);
    const response = await axiosInstance.get(
      `/analytics-warehouse-options?${params.toString()}`,
      signal ? { signal } : undefined,
    );
    return response.data;
  },

  // Starting warehouse for single-select pages that require one: the
  // client's default warehouse when it is offered, else the first offered.
  fetchDefault: async (clientId) => {
    const response = await analyticsWarehouseService.fetch({ clientId, limit: 1 });
    return pickDefaultAnalyticsWarehouse(response);
  },
};
